import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
import addSpecialMatter from './components/addSpecialMatter/index.vue'

export default {
  mixins: [services],
  components: {
    addSpecialMatter
  },
  data() {
    return {
      loading: false,
      lists: [],
      pageIndex: 1,
      pageSize: 10,
      totalSize: '',
      pageSizes: [10, 20, 50],
      query: this.getQuery(),
      searchVisiable: false,
      MatterId: '', // 事项id
      MatterTypes: []
    }
  },
  methods: {
    getQuery() {
      return cloneDeep({
        MatterTypeId: "",
        Initiator: "",
        PickUp: "",
        Executor: "",
        OrderCode: "",
        Remark: "",
        ExecutTimeStart: "",
        ExecutTimeEnd: "",
      });
    },
    selsChange: function (sels) {
      this.sels = sels;

    },
    /*搜索*/
    toggleSearch() {
      this.searchVisiable = !this.searchVisiable;
    },
    // 新增特殊事项
    addSpecialMatter() {
      this.$refs.refAddSpecialMatter.show({
        //id: row.OrderId
      });
    },
    currentRow(newRow, oldRow) {
      if (!newRow) return;
      this.MatterId = newRow.Id;
    },
    //修改特殊事项
    changeSpecialMatter() {
      if (this.MatterId !== '') {
        this.$refs.refAddSpecialMatter.show({
          id: this.MatterId,
          isChange: true
        });
      } else {
        this.$notify({
          title: '提示',
          message: '请先选择需要修改的事项',
          type: 'warning'
        })
      }
    },

    //查询
    onQuerySubmit: function () {
      this.pageIndex = 1;
      this.getList();
    },
    //重置
    onQueryClean: function () {
      this.query = this.getQuery();
      this.getList();
    },
    // 删除
    delRule(index, row) {
      this.$confirm('确认删除吗？', '提示', {}).then(() => {
        this.DelList(row.Id)
      })
    },
    //分页功能
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.pageIndex = val;
      this.getList();
    },
  },
  created: function () {
    this.pageIndex = 1;
    this.getList();
  },
  computed: {
    arrowClass() {
      return {
        'el-icon-arrow-down': !this.searchVisiable,
        'el-icon-arrow-up': this.searchVisiable
      };
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/Memorandum/SpecialMatter/vm.js